export const featuredProjects = [
  { text: "Howell Reclaimed Pine", href: "/projects/howell-reclaimed-tobacco-pine" },
  { text: "Brighton Mercier Hickory", href: "/projects/brighton-mercier-hickory" },
  { text: "Birmingham Viking White Oak", href: "/projects/birmingham-viking-white-oak" },
  { text: "Birmingham Walnut", href: "/projects/birmingham-rift-quartered-walnut" },
  { text: "Lexington Reclaimed Oak", href: "/projects/lexington-reclaimed-oak" },
  { text: "Northville Custom Walnut", href: "/projects/northville-walnut" },
  { text: "Plymouth Custom White Oak", href: "/projects/plymouth-custom-white-oak" },
  { text: "Harbor Springs Maple", href: "/projects/harbor-springs-maple" },
  { text: "Ann Arbor Commercial Refinishing", href: "/projects/ann-arbor-tech" },
];

// Header and hub additions must not change the footer's existing project list.
export const featuredHomeProjects = [
  ...featuredProjects.slice(0, 7),
  { text: "Ann Arbor White Oak", href: "/projects/ann-arbor-wide-white-oak" },
  ...featuredProjects.slice(7),
];